import { render } from "./noticeNews.vue?vue&type=template&id=7d4abee2&scoped=true"
import script from "./noticeNews.vue?vue&type=script&lang=js"
export * from "./noticeNews.vue?vue&type=script&lang=js"

import "./noticeNews.vue?vue&type=style&index=0&id=7d4abee2&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d4abee2"]])

export default __exports__